<mat-action-list>
  <button mat-list-item *ngFor="let item of staff" (click)="onSelectedItem(item)">
    <mat-icon mat-list-icon *ngIf="!item.device_id">person</mat-icon>
    <mat-icon mat-list-icon *ngIf="item.device_id">phone_android</mat-icon>
    <span [title]="item.name">{{ item.name }}</span>
  </button>
</mat-action-list>
